import React from "react";
import "./button.scss";

const Button = ({ text, onClick, disabled = false, backgroundColor = "blue", Icon, className='' }) => {

    const buttonClass = `custom-button ${backgroundColor} ${className}`;

    return (
        <button
            className={buttonClass}
            onClick={onClick}
            disabled={disabled}
        >
            {Icon && <Icon className="button-icon" />}
            <span className="button-text">{text}</span>
        </button>
    );
};

export default Button;
